// Context to provide dialog control functions to custom dialog components
import { createContext, useContext } from 'react'

export type TreeInputCtx = {
	name: string
	open: boolean
	onClose: () => void
	onSave: (results: CategorySearchResult[]) => void
}

export const TreeInputContext = createContext<TreeInputCtx>(null)

export const useTreeInput = () => {
	const ctx = useContext(TreeInputContext)
	if (!ctx) {
		throw new Error('Dialog must be used inside RHFTreeInput.')
	}
	return ctx
}

export default function RHFTreeInputProvider({
	children,
	value,
}: {
	children: React.ReactNode
	value: TreeInputCtx
}) {
	return <TreeInputContext.Provider value={value}>{children}</TreeInputContext.Provider>
}
